"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iInternalFeature = exports.iInternalFeaturePrice = exports.iFeaturePrice = exports.iPriceType = exports.iCurrency = exports.iFeature = exports.iAvailableFeatures = exports.VEKTORIO = exports.SUBPROJECT = exports.MODELSPACE = exports.PDFCOMPARE = exports.CONGRID = exports.SOKOSITE = exports.SOKOBID = exports.FILESTAB_PLUS = exports.FILESTAB = exports.VIEWER_2D = exports.AUTOMATIC_PRINT_ORDERS = exports.PRINT_ORDERS = void 0;
const t = require("io-ts");
exports.PRINT_ORDERS = 'PRINT_ORDERS';
exports.AUTOMATIC_PRINT_ORDERS = 'AUTOMATIC_PRINT_ORDERS';
exports.VIEWER_2D = 'VIEWER_2D';
exports.FILESTAB = 'FILESTAB';
exports.FILESTAB_PLUS = 'FILESTAB_PLUS';
exports.SOKOBID = 'SOKOBID';
exports.SOKOSITE = 'SOKOSITE';
exports.CONGRID = 'CONGRID';
exports.PDFCOMPARE = 'PDFCOMPARE';
exports.MODELSPACE = 'MODELSPACE';
exports.SUBPROJECT = 'SUBPROJECT';
exports.VEKTORIO = 'VEKTORIO';
exports.iAvailableFeatures = t.keyof({
    PRINT_ORDERS: exports.PRINT_ORDERS,
    AUTOMATIC_PRINT_ORDERS: exports.AUTOMATIC_PRINT_ORDERS,
    VIEWER_2D: exports.VIEWER_2D,
    FILESTAB: exports.FILESTAB,
    FILESTAB_PLUS: exports.FILESTAB_PLUS,
    SOKOBID: exports.SOKOBID,
    SOKOSITE: exports.SOKOSITE,
    CONGRID: exports.CONGRID,
    PDFCOMPARE: exports.PDFCOMPARE,
    MODELSPACE: exports.MODELSPACE,
    SUBPROJECT: exports.SUBPROJECT,
    VEKTORIO: exports.VEKTORIO
});
exports.iFeature = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        constant: exports.iAvailableFeatures,
        perm: t.number,
        required: t.number,
        optionals: t.number
    }),
    t.partial({
        imagePath: t.union([t.string, t.undefined]),
        currency: t.string,
        code: t.string,
        price: t.number,
        enabled: t.boolean
    })
]);
exports.iCurrency = t.interface({
    uuid: t.string,
    code: t.string,
    number: t.number,
    currency: t.string
});
exports.iPriceType = t.interface({
    uuid: t.string,
    id: t.number,
    name: t.string,
    description: t.string,
    type: t.string
});
exports.iFeaturePrice = t.interface({
    uuid: t.string,
    featureUuid: t.string,
    currency: t.string,
    priceType: t.string,
    price: t.union([t.number, t.undefined]),
    createdAt: t.string,
    updatedAt: t.string,
    deletedAt: t.string
});
exports.iInternalFeaturePrice = t.interface({
    uuid: t.string,
    featureUuid: t.string,
    currency: t.union([exports.iCurrency, t.undefined]),
    priceType: t.union([exports.iPriceType, t.undefined]),
    price: t.union([t.number, t.undefined]),
    createdAt: t.string,
    updatedAt: t.string,
    deletedAt: t.string
});
exports.iInternalFeature = t.intersection([
    t.interface({
        uuid: t.string
    }),
    exports.iInternalFeaturePrice,
    t.partial({
        imagePath: t.union([t.string, t.undefined]),
    })
]);
//# sourceMappingURL=feature.js.map